import {validate} from "@common/util";

export const validateOptions = {
    rules: {
        mbrId: {
            required: true,
            userId: true
        },
        mbrPw: {
            required: true,
            pw: true,
        },
        mbrPwConfirm: {
            equals: "#mbrPw"
        },
        csNm: {
            required: true
        },
        email: {
            required: true,
            email: true
        },
        mblNo: {
            required: true,
            phone: true
        },
        brno: {
            required: true,
            brno: true,
            condition: { id: "#chkBrno", values: ["F", "C"] }
        },
        coNm: {
            conditionRequired: { id: "#chkBrno", value: "C" }
        },
        brcFile: {
            conditionRequired: { id: "#chkBrno", value: "C" }
        }
    },
    messages: {
        mbrId: {
            required: "아이디를 입력해 주세요.",
            userId: "5~20자, 영문/숫자로 입력해 주세요."
        },
        mbrPw: {
            required: "비밀번호를 입력해 주세요.",
            pw: "8~20자, 영문/숫자/특수문자 모두 포함해서 입력해 주세요.",
        },
        mbrPwConfirm: {
            equals: "비밀번호가 일치하지 않습니다."
        },
        csNm: {
            required: "이름을 입력해 주세요."
        },
        email: {
            required: "이메일을 입력해 주세요.",
            email: "이메일 형식에 맞게 입력해 주세요."
        },
        mblNo: {
            required: "휴대전화 번호를 입력해 주세요.",
            phone: "휴대전화 번호 형식에 맞게 입력해 주세요."
        },
        brno: {
            required: "사업자등록번호를 입력해 주세요.",
            brno: "사업자등록번호 형식에 맞게 입력해 주세요.",
            condition: "사업자등록번호 확인해 주세요."
        },
        coNm: {
            conditionRequired: "사업자명을 입력해 주세요."
        },
        brcFile: {
            conditionRequired: "사업자등록증을 선택해 주세요."
        }
    },
    showErrors: validate.showErrors
};